const API_BASE_URL = 'https://odoo.core.daisies.mx/odoo-firebase-core/odoo-import';

export const doctorService = {
  async getAvailabilityByDatePublic(specialtyId, durationId, date, isExtra = false, tz = 'America/Mexico_City') {
    const payload = {
      params: {
        access_token: process.env.REACT_APP_ACCESS_TOKEN,
        account_id: 1,
        res_id: 1,
        res_model: 'dais.consultation',
        res_method: 'create_include_consultation_by_user_v2_public',
        res_params: {
          specialty_id: specialtyId,
          duration_id: durationId,
          date: date,
          is_extra: isExtra,
          tz: tz
        }
      }
    };

    try {
      const response = await fetch(API_BASE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        console.warn(`[doctorService] HTTP error: ${response.status}`);
        return null;
      }

      return await response.json();
    } catch (err) {
      console.warn('[doctorService] Fetch error:', err);
      return null;
    }
  },
};
